import { useEffect, useState } from "react"
import Wrapper from "./Subscription.styles"
import axios from "axios"
import LocalStorage, { Keys } from "../../Storage/LocalStorage"

export const Subscription = ({data,show,isMandatory}) => {

    const [subs, setSubs] = useState(() => {
        const storedSub = LocalStorage.get(Keys.CURRENT_SUBSCRIPTION);
        if (storedSub) {
            // Handle both object and string cases for backward compatibility
            return typeof storedSub === 'string' ? storedSub : storedSub.subscriptionId;
        }
        return null;
    })
    const [status, setStatus] = useState("Set")

    const getAssets = (e) => {
        if(subs){
            setStatus("Loading Assets ...")
            e.target.disabled = true
            const selectedSubscription = data.find(sub => sub.subscriptionId === subs)
            LocalStorage.set(Keys.CURRENT_SUBSCRIPTION, selectedSubscription)
            delete axios.defaults.headers.common['SubscriptionId'];
            axios.defaults.headers.common['SubscriptionId'] = subs
            delete axios.defaults.headers.common['AssetId'];
            axios.defaults.headers.common['AssetId'] = selectedSubscription.assets[0].assetId
            LocalStorage.set(Keys.CURRENT_ASSET, selectedSubscription.assets[0])
            e.target.disabled = false
            setStatus("Set")
            show(false)
            window.location.reload()
        }else{
            setStatus("Please select subscription")
            setTimeout(() => {
                setStatus("Set")
            },2000)
        }
    }
    
    const change = e => {
        setSubs(e.target.value)
        setStatus('Set')
    }

    useEffect(() => {
        // Only allow click-outside-to-close if not mandatory
        if (!isMandatory) {
            const handleClick = e => {
                if(e.target.classList.contains('subscriptionModal')) {
                    show(false)
                }
            };

            const modalElement = window.document.querySelector('.subscriptionModal:not(.container)');
            if (modalElement) {
                modalElement.addEventListener('click', handleClick);
            }
            
            return () => {
                if (modalElement) {
                    modalElement.removeEventListener('click', handleClick);
                }
            };
        }
    }, [isMandatory, show]);

    return (
        <Wrapper className="subscriptionModal">
            <section className={!status.includes('ing') ? "" : "loading" }>
                <h1>Please select subscription</h1>
                <select onChange={change} value={subs || ""}>
                    <option disabled value="">-- Select subscription --</option>
                    {
                        data.map(sub => <option key={sub.subscriptionId} value={sub.subscriptionId}>{sub.displayName}</option>)
                    }
                </select>
                <br />
                <input type="button" value={status} className="primary" onClick={getAssets} />
            </section>
        </Wrapper>
    )
}